// FoodEnergyCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import {
  SecondAds,
  FirstAds,
  MobileUnderCalAds
} from "../../Ads";
import { SERVER_URL } from "./ConstantsHealthCalculator";
import { FoodEnergy_EndPoint } from "./ConstantsHealthCalculator";
import SharedHelmet from "../Helmet";
const TITLE = "Konversi Kalori ke Joule dan Kilojoule";
const DESCRIPTION =
  "Apakah Anda ingin mengkonversi kalori ke satuan ukur lain seperti joule dan kilojoule? Gunakan kalkulator ini untuk mendapatkan nilai spesifik dengan mudah dan cepat";
const KEYWORDS =
  "konversi kalori ke joule, konversi kalori ke kilojoule, cara mengkonversi kalori ke joule, cara mengkonversi kalori ke kilojoule, tabel konversi kalori ke joule dan kilojoule, kalori dan joule dan kilojoule: konversi dan persamaan, kalkulator konversi kalori ke joule dan kilojoule, konversi dari satuan kalori ke satuan joule, konversi dari satuan kalori ke satuan kilojoule, cara melakukan konversi antara kalori, joule, dan kilojoule";
const OG_URL = "https://do-calculate.com/calculator/id/foodenergy/";
const apiEndpoint = `${SERVER_URL}/${FoodEnergy_EndPoint}`;
function FoodEnergyCalculator() {
  const [value, setValue] = useState(1);
  const [unitFrom, setUnitFrom] = useState("kcal");
  const [unitTo, setUnitTo] = useState("kcal");
  const [newValue, setNewValue] = useState(1);
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleValueChange = (event) => {
    setValue(event.target.value);
  };
  const handleUnitFromChange = (event) => {
    setUnitFrom(event.target.value);
  };
  const handleUnitToChange = (event) => {
    setUnitTo(event.target.value);
  };
  const handleNewValueChange = (event) => {
    setNewValue(event.target.value);
  };
  const calculateFoodEnergy = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ value, unitFrom }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        if (unitTo === "kcal") {
          setNewValue(data.result.kcal);
        } else if (unitTo === "cal") {
          setNewValue(data.result.cal);
        } else if (unitTo === "J") {
          setNewValue(data.result.J);
        } else if (unitTo === "kJ") {
          setNewValue(data.result.kJ);
        }
        setError(null);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                Kalkulator konversi kalori ke joule dan kilojoule menghitung nilai konversi energi antara berbagai satuan. Fungsi ini menerima nilai dan satuan sebagai input dan mengkonversi nilai tersebut ke nilai energi setara dalam satuan lain. Satuan yang didukung untuk konversi termasuk kkal (kilokalori), kal (kalori kecil), kJ (kilojoule), dan J (joule).
                <br />
                Anda dapat menggunakan fungsi ini untuk mengkonversi nilai energi antara satuan yang disebutkan dan mendapatkan nilai setara dalam satuan lain.
                <br />
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Kalkulator Konversi Energi Makanan
                </div>
                <hr />

                <div className="d-flex align-items-center justify-content-center gap-2 flex-wrap mb-3">
                  <input
                    type="number"
                    id="weightNumberFrom"
                    value={value}
                    onChange={handleValueChange}
                    className="form-control"
                    placeholder="175"
                    style={{ width: "90%" }}
                  />
                  <label
                    htmlFor="unitFrom"
                    className="mb-0 fw-bold"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Satuan
                  </label>
                  <select
                    id="unitFrom"
                    className="form-select"
                    style={{ width: "90%" }}
                    value={unitFrom}
                    onChange={handleUnitFromChange}
                  >
                    <option value="kcal">Kilokalori (kkal)</option>
                    <option value="cal">kalori (kal)</option>
                    <option value="kJ">Kilojoule (kJ)</option>
                    <option value="J">joule (J)</option>
                  </select>
                </div>

                <div className="text-center fw-bold fs-4 mb-3">=</div>

                <div className="d-flex align-items-center justify-content-center gap-2 flex-wrap mb-3">
                  <input
                    type="number"
                    id="weightNumberTo"
                    value={newValue}
                    onChange={handleNewValueChange}
                    className="form-control"
                    placeholder="0"
                    style={{ width: "90%" }}
                    readOnly
                  />
                  <label
                    htmlFor="unitTo"
                    className="mb-0 fw-bold"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Satuan
                  </label>
                  <select
                    id="unitTo"
                    className="form-select"
                    style={{ width: "90%" }}
                    value={unitTo}
                    onChange={handleUnitToChange}
                  >
                    <option value="kcal">Kilokalori (kkal)</option>
                    <option value="cal">kalori (kal)</option>
                    <option value="J">joule (J)</option>
                    <option value="kJ">Kilojoule (kJ)</option>
                  </select>
                </div>

                <hr />
                <div className="text-center">
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateFoodEnergy}
                  >
                    Hitung
                  </button>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-auto">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> Terjadi Kesalahan :</u>
                    </b>
                    Harap masukkan semua kolom dengan benar.
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Konversi Kalori ke Joule dan Kilojoule: Metode, Tabel, dan Perhitungan:
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Artikel: Kalori dan Cara Menghitungnya untuk Mencapai Nutrisi yang Tepat
                  </h2>
                </u>
                <br />
                <p>
                  Kalori digunakan sebagai satuan ukur energi dalam bidang nutrisi dan ilmu gizi. Namun, terkadang ada kebutuhan untuk mengkonversi kalori ini ke satuan lain seperti joule dan kilojoule. Dalam artikel ini, kita akan membahas cara mengkonversi kalori ke joule dan kilojoule serta menyediakan tabel konversi untuk membantu Anda melakukannya.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Apa itu Kalori, Joule, dan Kilojoule?
                  </h2>
                </u>
                <ul>
                  <li>
                    Kalori (Calories): adalah satuan ukur energi yang umum dalam bidang nutrisi. Digunakan untuk mengukur jumlah energi yang dikonsumsi atau terkandung dalam makanan dan minuman. Kalori disingkat "kal".
                  </li>
                  <li>
                    Joule (Joule): adalah satuan internasional untuk mengukur energi. Digunakan secara luas dalam sains dan teknik. 1 joule setara dengan sekitar 0,239 kalori.
                  </li>
                  <li>
                    Kilojoule (Kilojoule): adalah satuan ukur energi yang juga digunakan secara luas. 1 kilojoule setara dengan 239 kalori.
                  </li>
                </ul>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Cara Mengkonversi Kalori ke Joule:
                  </h2>
                </u>
                <br />
                <p>
                  Untuk mengkonversi kalori ke joule, Anda dapat menggunakan hubungan berikut: 1 kalori = 4,184 joule. Sederhananya, kalikan jumlah kalori dengan 4,184 untuk mendapatkan joule. Misalnya, jika suatu makanan mengandung 100 kalori, maka setara dengan 418,4 joule.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Cara Mengkonversi Kalori ke Kilojoule:
                  </h2>
                </u>
                <br />
                <p>
                  Untuk mengkonversi kalori ke kilojoule, Anda dapat menggunakan hubungan berikut: 1 kalori = 0,004184 kilojoule. Sederhananya, bagi jumlah kalori dengan 239 untuk mendapatkan kilojoule. Misalnya, jika suatu makanan mengandung 100 kalori, maka setara dengan 0,4184 kilojoule.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Tabel Konversi Kalori ke Joule dan Kilojoule:
                  </h2>
                </u>
                <br />
                Untuk kemudahan penggunaan, berikut adalah tabel yang menunjukkan konversi kalori ke joule dan kilojoule:
                <table >
                  <thead>
                    <tr>
                      <th >
                        Kalori
                      </th>
                      <th >Joule</th>
                      <th >Kilojoule</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>4,184</td>
                      <td>0,004184</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>41,84</td>
                      <td>0,04184</td>
                    </tr>
                    <tr>
                      <td>50</td>
                      <td>209,2</td>
                      <td>0,2092</td>
                    </tr>
                    <tr>
                      <td>100</td>
                      <td>418,4</td>
                      <td>0,4184</td>
                    </tr>
                    <tr>
                      <td>500</td>
                      <td>2092</td>
                      <td>2,092</td>
                    </tr>
                  </tbody>
                </table>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Bagaimana Kalkulator Ini Bekerja Menghitung Nilai Energi Antara Berbagai Satuan:
                  </h2>
                </u>
                <br />
                <p>
                  Kalkulator ini mengkonversi nilai energi antara berbagai satuan. Sederhananya, Anda dapat menggunakan kalkulator ini untuk mengkonversi nilai energi dari satu satuan ke satuan lainnya.
                </p>
                <p>
                  Saat menggunakan kalkulator ini, Anda harus memberikannya nilai energi yang ingin Anda konversi, serta satuan ukur aslinya. Kemudian, kalkulator akan mengkonversi nilai ini ke satuan lain yang tersedia dan memberi Anda nilai setaranya. Dengan menggunakan kalkulator ini, Anda dapat mempermudah proses konversi nilai energi dengan mudah dan akurat, bahkan jika Anda tidak ahli di bidang ini.
                </p>
                <hr />
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default FoodEnergyCalculator;
